import React from 'react'
import classNames from 'classnames'
import { bool, node, object, string } from 'prop-types'
import Grid from '@/component/Primitive/Grid'

import styles from './Column.module.scss'

const Column = ({ children, column, fixedWidth, showFirst, trailingGap }) => {
  if (fixedWidth) {
    return (
      <div
        className={classNames(
          styles.FixedWidthColumn,
          showFirst && styles['show-first']
        )}
      >
        {children}
      </div>
    )
  }

  return (
    <Grid.Item
      traiingGap={trailingGap}
      width={column.width && { d: column.width / 4 }}
    >
      {children}
    </Grid.Item>
  )
}

Column.propTypes = {
  children: node,
  column: object,
  fixedWidth: bool,
  showFirst: bool,
  trailingGap: string
}

export default Column
